import {
  HostEnvironment,
  PaldeskRemoteVersions,
} from '@paldesk/module-federation/core';
import { HeaderTestRemoteVersion } from '@paldesk/module-federation/remotes-registry';

export class EnvironmentBase {
  static remotes: PaldeskRemoteVersions = {
    ...HeaderTestRemoteVersion,
  };

  static application_insights_key = '';
  static google_analytics_id = '';
  static palfinger_api_management = '';
  static palfinger_api_management_subs_key = '';
  static oidc_clientid = '';
  static oidc_scope = '';
  static env: HostEnvironment = 'test';
  static palfinger_app_gateway = '';
  static buildId = '';
  static production = false;

  static domainsForApiManagementSubsKey: string[];

  static identityServerAuthConf: {
    whitelistedDomains: string[];
    whitelistedRoutes: string[];
    blacklistedRoutes: string[];
  } = {
    whitelistedDomains: [],
    whitelistedRoutes: [],
    blacklistedRoutes: [],
  };

  static LINKS: {
    SECURITY_TOKEN_SERVICE: string;
    POST_LOGOUT_REDIRECT_URI: string;
    PALDESK_BASEPATH: string;
    HOME: string;
    STATUS_PALDESK_PAGE: string;
    WORKSHOP_GUIDE_URI: string;
  } = {
    SECURITY_TOKEN_SERVICE: '',
    POST_LOGOUT_REDIRECT_URI: '',
    PALDESK_BASEPATH: '',
    HOME: '',
    STATUS_PALDESK_PAGE: '',
    WORKSHOP_GUIDE_URI: '',
  };

  static FEATURE_FLAGS: {
    AUTOMATIC_CREDIT_NOTE_FOR_COD_DENMARK: string;
  } = {
    AUTOMATIC_CREDIT_NOTE_FOR_COD_DENMARK: '',
  };
}
